var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _ellipse, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterIcon0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12387_385805)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "#67D24D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0712 103.005C75.749 107.105 79.5511 125.734 80.9315 132.953C81.2084 134.453 82.7101 135.348 84.0951 134.839L93.196 131.495C96.0538 130.444 94.5846 125.971 91.6599 126.839C91.2558 126.962 90.8737 127.077 90.5 127.214C88.5791 127.894 86.7449 125.958 87.4238 124.003C91.5084 112.373 91.6257 98.8417 91.5527 94.5016C91.5217 93.1951 90.5036 92.1223 89.2288 92.0481C87.3511 91.963 84.6096 92.583 81.8397 93.6009C75.7065 95.8549 69.4449 100.068 72.0712 103.005Z",
    fill: "url(#paint0_linear_12387_385805)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.9696 124.531C-3.48434 166.666 13.504 153.228 14.7532 150.398C14.7532 150.398 28.2849 152.579 24.9579 141.45C24.7106 140.667 24.5036 139.995 24.3235 139.395C24.3201 139.605 24.3116 139.691 24.3116 139.691C24.3116 139.691 21.9826 131.605 24.3235 139.395C24.4671 137.929 24.8836 131.413 22.1453 128.551C19.0332 125.328 11.1881 130.208 11.1881 130.208C11.1881 130.208 -22.6148 96.8004 -19.9837 38.0675C-19.9837 38.0675 -34.4413 82.4321 -18.9696 124.531Z",
    fill: "url(#paint1_linear_12387_385805)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.737 93.6221C110.737 93.6221 101.599 94.9841 101.314 99.4554C101.081 103.409 105.618 108.105 106.677 109.129C103.416 101.677 106.877 109.347 106.877 109.347C106.877 109.347 106.815 109.286 106.677 109.129C106.928 109.703 107.205 110.349 107.524 111.105C112.195 121.74 121.095 111.316 121.095 111.316C123.879 112.664 145.526 111.903 130.041 69.7675C114.569 27.6689 74.8239 3.22467 74.8239 3.22467C114.862 46.2761 110.737 93.6221 110.737 93.6221Z",
    fill: "url(#paint2_linear_12387_385805)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5716 96.5961C91.5765 95.7613 91.5703 95.0541 91.5609 94.4979C91.5299 93.1915 90.5118 92.1186 89.237 92.0445C87.3593 91.9594 84.6178 92.5793 81.8479 93.5973C75.7147 95.8513 69.4532 100.065 72.0794 103.001C72.9334 103.953 73.794 105.689 74.6295 107.883C81.322 104.289 86.929 100.507 91.5716 96.5961Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.747 -18.5236C56.1959 -13.5619 51.2547 2.07152 56.1846 5.79316C61.0871 9.52492 74.0064 -0.0446341 77.5575 -5.00632C81.0706 -9.9864 79.9547 -17.019 75.0143 -20.7691C71.9006 -23.1196 68.0445 -23.5793 64.7409 -22.3652C62.7864 -21.6469 61.0413 -20.3584 59.747 -18.5236Z",
    fill: "url(#paint3_linear_12387_385805)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9074 -13.5191C75.0493 -18.575 71.5634 -20.7184 65.7983 -18.6001C60.0331 -16.4818 60.583 -8.26261 61.7447 -5.10152C63.1969 -1.15015 65.4135 0.398329 70.533 -1.48315C75.6525 -3.36462 78.7654 -8.46324 76.9074 -13.5191Z",
    fill: "url(#paint4_linear_12387_385805)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0973 -0.431801C-26.2307 20.2689 -22.0643 43.5783 -23.2198 63.993C-24.2082 83.3174 -4.68569 141.845 66.2776 109.004C137.241 76.1631 106.273 24.3403 77.4498 5.38895C52.6329 -10.7721 28.3028 -3.59442 21.8004 -1.2047C20.675 -0.791095 20.0973 -0.431801 20.0973 -0.431801Z",
    fill: "url(#paint5_linear_12387_385805)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3147 25.8301C109.675 46.3482 107.067 64.3565 98.3456 80.7903C89.5765 97.0945 49.9345 120.923 15.0119 113.18C-12.4035 106.94 -20.7177 77.3658 -23.2381 64.3287C-23.9587 83.9952 -4.17427 141.691 66.2874 109.034C131.062 79.0553 110.911 33.1063 84.9237 11.0556C88.465 14.8985 92.387 19.7774 96.3147 25.8301Z",
    fill: "url(#paint6_linear_12387_385805)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2241 25.4029C89.028 27.5902 87.9665 29.9931 85.8531 30.7697C83.7398 31.5464 81.3749 30.4028 80.571 28.2155C79.7671 26.0281 80.8287 23.6253 82.942 22.8486C85.0554 22.072 87.4203 23.2155 88.2241 25.4029ZM100.239 41.8291C102.761 40.9022 104.028 38.0343 103.069 35.4235C102.109 32.8126 99.2868 31.4475 96.7647 32.3744C94.2427 33.3013 92.976 36.1692 93.9355 38.78C94.895 41.3908 97.7174 42.756 100.239 41.8291ZM103.395 60.047C103.888 61.3872 103.238 62.8593 101.943 63.3351C100.649 63.8108 99.1999 63.1101 98.7074 61.7699C98.2148 60.4297 98.865 58.9576 100.16 58.4818C101.454 58.0061 102.903 58.7068 103.395 60.047ZM82.0671 65.3553C87.1792 63.4766 89.747 57.6642 87.8024 52.373C85.8578 47.0818 80.1372 44.3154 75.0251 46.1942C69.913 48.073 67.3452 53.8854 69.2898 59.1765C71.2344 64.4677 76.955 67.2341 82.0671 65.3553ZM96.0564 82.3353C97.3011 85.7222 95.6584 89.4424 92.3873 90.6446C89.1163 91.8467 85.4555 90.0756 84.2107 86.6887C82.966 83.3018 84.6087 79.5817 87.8798 78.3795C91.1509 77.1774 94.8117 78.9484 96.0564 82.3353ZM54.4246 71.5044C56.1977 70.8528 57.0886 68.8378 56.4146 67.0037C55.7405 65.1696 53.7568 64.211 51.9837 64.8626C50.2107 65.5142 49.3197 67.5293 49.9938 69.3634C50.6678 71.1975 52.6516 72.156 54.4246 71.5044ZM67.4594 35.1047C68.3407 37.5029 67.1763 40.1375 64.8586 40.9893C62.5409 41.8411 59.9476 40.5875 59.0662 38.1893C58.1848 35.7911 59.3492 33.1564 61.6669 32.3047C63.9846 31.4529 66.578 32.7065 67.4594 35.1047Z",
    fill: "url(#paint7_linear_12387_385805)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.09923 82.7892C-6.09923 82.7892 -10.5333 104.483 24.2141 108.846C58.5117 113.191 77.7842 96.3046 88.3497 84.5425C93.7347 78.578 97.9871 67.1203 96.7937 58.8093C94.7208 44.7289 80.855 41.1209 71.9338 51.0877C64.365 59.5497 60.6257 62.0848 47.4334 66.3376C24.8557 73.6274 19.0005 70.9078 6.79356 72.4163C5.00567 72.6153 3.46291 72.9991 2.0966 73.5012C-5.5938 76.3275 -6.09923 82.7892 -6.09923 82.7892Z",
    fill: "url(#paint8_radial_12387_385805)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12387_385805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: 45,
    width: 104,
    height: 65
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.09923 82.7892C-6.09923 82.7892 -10.5333 104.483 24.2141 108.846C58.5117 113.191 77.7842 96.3046 88.3497 84.5425C93.7347 78.578 97.9871 67.1203 96.7937 58.8093C94.7208 44.7289 80.855 41.1209 71.9338 51.0877C64.365 59.5497 60.6257 62.0848 47.4334 66.3376C24.8557 73.6274 19.0005 70.9078 6.79356 72.4163C5.00567 72.6153 3.46291 72.9991 2.0966 73.5012C-5.5938 76.3275 -6.09923 82.7892 -6.09923 82.7892Z",
    fill: "url(#paint9_radial_12387_385805)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12387_385805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3621 66.6211C45.8121 68.9891 47.7399 70.9899 49.9016 72.3262C53.8189 74.7459 58.9097 75.5928 61.3557 71.5046C63.048 68.6776 62.9082 64.514 61.3326 61.0905C60.8714 60.0858 60.3508 59.0805 59.7707 58.1489C57.4528 61.2472 54.3887 63.803 49.637 65.2886C47.7946 65.8638 46.044 66.2931 44.3621 66.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3391 45.4857C74.3391 45.4857 73.2101 49.4394 71.8229 48.2371C71.4914 48.8101 69.1751 50.1114 68.8776 50.7806C65.9543 57.3367 63.0763 58.0304 63.0763 58.0304C65.8664 61.2339 68.9046 63.3705 71.6707 64.0145C76.1109 65.0515 82.3543 61.5365 80.7285 55.193C78.2446 48.4342 77.578 49.6141 74.3391 45.4857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9487 70.5814C23.705 71.2526 23.4628 72.4031 23.3802 73.2991C23.4734 76.9665 24.6266 81.4479 27.6536 83.8065C30.2612 85.8382 35.6545 85.241 38.2835 81.7524C41.487 76.1566 39.314 70.6072 39.3825 67.4666C35.3426 68.9513 33.95 69.4404 30.6606 69.7815C30.6606 69.7815 26.9821 70.1972 23.9487 70.5814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3464 81.4097C14.4011 85.2159 11.1242 86.5546 7.29214 83.9193C4.30463 81.8656 2.86209 77.8706 3.36536 74.3922C3.49503 73.4917 3.7232 72.7196 4.03867 72.0527C5.03029 71.7849 7.11513 71.389 8.32713 71.2651C13.073 70.7782 19.8586 70.9691 19.8586 70.9691C19.5985 73.7348 19.3454 77.5538 17.3464 81.4097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07317 76.8329C9.13065 70.833 18.1992 72.7781 19.5675 74.0167C19.8002 73.2752 19.6929 72.5187 19.7901 71.743C15.0859 70.4099 11.6517 71.7166 6.93561 72.2846C5.73123 72.4293 4.64271 72.6503 3.65219 72.9248C3.32484 73.5556 3.08034 74.2833 2.93044 75.1288C2.34904 78.3946 3.92514 82.3227 6.59699 83.9477C8.33385 84.7209 7.47577 84.3056 9.5027 85.0219C7.54996 83.5477 3.78545 81.3217 6.07317 76.8329Z",
    fill: "#F5C5A9"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3372 94.03C49.4416 95.0093 48.5079 96.0748 47.2291 96.328C46.6244 96.454 45.9905 96.3739 45.3926 96.3288C41.1228 95.9718 36.6596 96.4804 33.139 98.8578C29.792 101.075 27.5212 105.208 28.1022 109.256C55.8686 111.548 73.2513 99.6943 83.984 89.1045C79.8655 85.4895 74.1117 83.7517 68.7044 84.222C66.584 84.3994 64.5318 84.8887 62.5449 85.6189C57.9155 87.3203 53.7285 90.3519 50.3372 94.03Z",
    fill: "url(#paint10_radial_12387_385805)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.994 89.1053C81.7999 87.1854 79.1525 85.8111 76.3457 84.999C76.4781 85.3518 76.5783 85.7165 76.6065 86.0908C76.8057 88.7536 75.0777 91.112 73.1827 92.8911C70.8545 95.0756 68.137 96.8185 65.1947 98.0117C64.5538 98.271 63.8842 98.5073 63.1903 98.4826C61.215 98.4112 59.9088 96.386 58.7907 94.6889C57.6726 92.9918 55.8207 91.2091 53.9803 91.8981C54.2336 91.2679 54.4848 90.6356 54.7388 90.0037C53.1646 91.2187 51.6899 92.572 50.3426 94.0295C49.4507 94.9951 48.5158 96.0605 47.235 96.3242C47.2326 96.3251 47.2281 96.3239 47.2258 96.3248L52.4826 98.0074C53.4641 98.3223 54.4832 98.6583 55.2356 99.3862C55.988 100.114 56.3745 101.357 55.8321 102.233C55.426 102.889 54.6387 103.161 53.9082 103.375C47.5432 105.23 40.8324 105.913 34.1844 105.381C33.5316 105.329 32.8604 105.259 32.271 104.953C30.9448 104.262 30.4034 102.451 30.8532 101.021C30.8916 100.898 30.9664 100.797 31.0156 100.681C28.9073 102.986 27.6626 106.137 28.0991 109.247C55.8631 111.539 73.2517 99.6947 83.994 89.1053Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1472 96.6018C54.8435 97.3841 56.0973 98.6089 56.8103 99.5932C57.1722 100.085 57.4238 100.509 57.572 100.817C57.7161 101.121 57.798 101.292 57.798 101.292C57.798 101.292 57.1858 100.854 56.2267 100.251C55.2647 99.6437 53.9419 98.9297 52.4609 98.2444C50.9757 97.5663 49.5781 97.0308 48.4998 96.7025C47.4281 96.3704 46.7059 96.1952 46.7059 96.1952C46.7059 96.1952 46.8809 96.1421 47.1919 96.0474C47.5097 95.9529 47.9766 95.8597 48.567 95.805C49.7412 95.6882 51.4474 95.8249 53.1472 96.6018Z",
    fill: "#831434"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.6721,
    cy: 44.7326,
    rx: 56.6153,
    ry: 44.576,
    transform: "rotate(-20.1789 36.6721 44.7326)",
    fill: "url(#paint11_linear_12387_385805)",
    fillOpacity: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5062 25.7482C54.4257 36.4132 49.2551 48.1269 38.9574 51.9114C28.6596 55.6959 17.1343 50.1182 13.2148 39.4532C9.29525 28.7882 14.4658 17.0745 24.7636 13.29C35.0613 9.50543 46.5866 15.0832 50.5062 25.7482Z",
    fill: "#89C072"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6425 26.4326C52.1698 36.0302 47.516 46.5719 38.2481 49.9779C28.9801 53.384 18.6076 48.3647 15.0803 38.767C11.5531 29.1694 16.2068 18.6277 25.4748 15.2217C34.7427 11.8156 45.1153 16.8349 48.6425 26.4326Z",
    fill: "url(#paint12_radial_12387_385805)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4761 29.0715C42.3736 34.2347 39.8701 39.9058 34.8842 41.7381C29.8983 43.5705 24.3182 40.8703 22.4206 35.707C20.5231 30.5438 23.0267 24.8727 28.0126 23.0404C32.9984 21.208 38.5785 23.9082 40.4761 29.0715Z",
    fill: "url(#paint13_radial_12387_385805)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6692 30.8369C36.5565 33.2513 35.3855 35.9039 33.055 36.7604C30.72 37.6185 28.1099 36.3555 27.2226 33.9412C26.3354 31.5268 27.5061 28.8733 29.841 28.0152C32.1715 27.1587 34.7819 28.4226 35.6692 30.8369Z",
    fill: "#2E2A49"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9233 25.1657C82.5363 32.2758 79.0893 40.0849 72.2241 42.6079C65.359 45.1309 57.6754 41.4124 55.0624 34.3024C52.4494 27.1924 55.8964 19.3833 62.7616 16.8603C69.6267 14.3372 77.3103 18.0557 79.9233 25.1657Z",
    fill: "#89C072"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6803 25.6196C81.0318 32.0181 77.9293 39.0458 71.7507 41.3166C65.572 43.5873 58.657 40.2411 56.3055 33.8426C53.954 27.4442 57.0565 20.4164 63.2351 18.1457C69.4138 15.875 76.3288 19.2212 78.6803 25.6196Z",
    fill: "url(#paint14_radial_12387_385805)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8611 27.1634C75.1262 30.6055 73.4571 34.3862 70.1332 35.6078C66.8093 36.8294 63.0892 35.0292 61.8242 31.5871C60.5591 28.1449 62.2282 24.3642 65.5521 23.1426C68.876 21.9211 72.5961 23.7212 73.8611 27.1634Z",
    fill: "url(#paint15_radial_12387_385805)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6566 28.3418C71.2481 29.9514 70.4674 31.7198 68.9137 32.2908C67.3571 32.8629 65.617 32.0209 65.0255 30.4113C64.434 28.8017 65.2144 27.0327 66.7711 26.4606C68.3248 25.8896 70.065 26.7323 70.6566 28.3418Z",
    fill: "#2E2A49"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2795 48.9079C17.8925 56.0179 14.4455 63.8271 7.58031 66.3501C0.715159 68.8731 -6.96841 65.1546 -9.58142 58.0446C-12.1944 50.9346 -8.74738 43.1255 -1.88222 40.6024C4.98294 38.0794 12.6665 41.7979 15.2795 48.9079Z",
    fill: "#89C072"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0382 49.3644C16.3898 55.7628 13.2872 62.7906 7.10861 65.0613C0.929978 67.332 -5.98506 63.9858 -8.33656 57.5874C-10.6881 51.1889 -7.58556 44.1612 -1.40692 41.8905C4.77171 39.6197 11.6867 42.9659 14.0382 49.3644Z",
    fill: "url(#paint16_radial_12387_385805)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59453 51.1324C9.85956 54.5745 8.19051 58.3552 4.86659 59.5768C1.54268 60.7984 -2.1774 58.9982 -3.44243 55.5561C-4.70746 52.1139 -3.03841 48.3332 0.285507 47.1116C3.60942 45.8901 7.3295 47.6902 8.59453 51.1324Z",
    fill: "url(#paint17_radial_12387_385805)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39513 52.3122C5.98666 53.9217 5.20596 55.6901 3.65228 56.2611C2.09565 56.8332 0.355596 55.9912 -0.235935 54.3816C-0.827466 52.7721 -0.0469917 51.003 1.50963 50.431C3.06332 49.86 4.8036 50.7026 5.39513 52.3122Z",
    fill: "#2E2A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12387_385805",
    x1: 68.2547,
    y1: 98.5948,
    x2: 90.2376,
    y2: 90.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12387_385805",
    x1: -47.0792,
    y1: 48.0443,
    x2: -11.6985,
    y2: 35.0415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12387_385805",
    x1: 66.5509,
    y1: 6.28402,
    x2: 101.932,
    y2: -6.71877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12387_385805",
    x1: 74.2009,
    y1: -28.2539,
    x2: 46.6715,
    y2: -18.1365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12387_385805",
    x1: 61.0177,
    y1: -7.07959,
    x2: 77.102,
    y2: -12.9907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12387_385805",
    x1: -45.4433,
    y1: 13.5642,
    x2: 79.6037,
    y2: -32.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12387_385805",
    x1: -39.7087,
    y1: 29.1671,
    x2: 85.3358,
    y2: -16.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12387_385805",
    x1: 55.9877,
    y1: 85.6729,
    x2: 113.736,
    y2: 64.4497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CA64B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8234 82.7295) rotate(-20.1789) scale(41.5904 19.1886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8234 82.7295) rotate(-20.1789) scale(41.5904 19.1886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.4147 97.4706) rotate(-20.1789) scale(21.8234 8.30263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12387_385805",
    x1: 36.6721,
    y1: 0.156673,
    x2: 36.317,
    y2: 60.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8616 32.5995) rotate(-20.1789) scale(17.8785 18.5146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4481 32.3899) rotate(-20.1789) scale(9.61808 9.96024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.493 29.7309) rotate(-20.1789) scale(11.919 12.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.8424 29.3757) rotate(-20.1789) scale(6.41205 6.64016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.85094 53.4757) rotate(-20.1789) scale(11.919 12.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_12387_385805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.57585 53.3447) rotate(-20.1789) scale(6.41205 6.64016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12387_385805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterIcon0);
export default __webpack_public_path__ + "static/media/MonsterIcon0.95d63db46ab8cba9699a7406f6f8a881.svg";
export { ForwardRef as ReactComponent };